import { render, staticRenderFns } from "./accreditation-form.vue?vue&type=template&id=fea8be3e&scoped=true"
import script from "./accreditation-form.vue?vue&type=script&lang=js"
export * from "./accreditation-form.vue?vue&type=script&lang=js"
import style0 from "./accreditation-form.vue?vue&type=style&index=0&id=fea8be3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea8be3e",
  null
  
)

export default component.exports